<template>
  <div class="container">
    <div class="item">
      <cube-input placeholder="请输入备注名称" v-model="modifyName" :clearable="clearable"></cube-input>
    </div>
    <div class="tip">备注名称字数不超过10位，包含中英文、数字以及“_”。</div>
    <button class="btnsave"  @click="save">保存</button>
  </div>
</template>
<script>
import Common from '../../assets/js/common.js'
import axios from 'axios'
import { Popup } from 'vant'
import {mapState, mapMutations} from 'vuex'
import SettingInternet from '../../components/SettingInternet/SettingInternet.vue'


var api = process.env.BASE_URL
var isLocal = Common.getEvn()
export default {
  components: {
    [Popup.name]: Popup,
    SettingInternet
  },
  data () {
    return {
      show: false,
      clearable: true,
      eye: {
        open: true,
        reverse: false
      },
      showTip: false,
      quit: false,
      modifyName: localStorage.getItem('max_device_name'),
      deviceId: localStorage.getItem('max_device_id_ex'),
      userId: localStorage.getItem('max_userId')
    }
  },
  methods: {
    nextUpdate () {
      // this.settingWater()
      this.$router.back()
    },
    nowUpdate () {
      // this.settingWater()
      this.quit = true
      this.$router.back()
    },
    showPopup () {
      this.show = true
    },
    closePopup () {
      this.show = false
    },
    setCellular () {
      // console.log("device_id_ex: " + this.deviceId + "name: " + this.modifyName + "user_id: " + this.userId)
      this.toast = this.$createToast({
        time: 0,
        txt: ' 正在设置备注名称',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios.post('/Calendar/api/device/set/device/name/', {
          device_id_ex: this.deviceId,
          name: this.modifyName,
          user_id: this.userId
        })
        .then(this.setCellularSuccess)
        .catch(this.setCellularError)
      } else {
        axios.post(api + '/Calendar/api/device/set/device/name/', {
          device_id_ex: this.deviceId,
          name: this.modifyName,
          user_id: this.userId
        })
        .then(this.setCellularSuccess)
        .catch(this.setCellularError)
      }
    },
    setCellularSuccess (res) {
      this.toast.hide()
      // console.log("res.data------>>>>" + JSON.stringify(res.data))
      if (res.data.result === 0) {
        this.toast = this.$createToast({
          txt: '设置成功',
          type: 'txt'
        }).show()
        localStorage.setItem('max_device_name', this.modifyName)
        this.$router.go(-1)
      } else{
          alert(res.data.message)
      }
    //   else if (res.data.result === 1) {
    //       alert(res.data.message)
    //   }
    //   else if (res.data.result === 2) {
    //       alert(res.data.message)
    //   }
    //   else if (res.data.result === 3) {
    //       alert(res.data.message)
    //   }
    },
    setCellularError (error) {
      console.log(error)
      this.toast.hide()
    },
    save () {
      var reg = /^[\w\u4e00-\u9fa5]{1,10}$/
      if (!this.modifyName) {
        this.toast = this.$createToast({
          txt: '备注名称不能为空',
          type: 'txt'
        }).show()
        return false
      } else if (this.modifyName === localStorage.getItem('max_device_name')) {
        this.toast = this.$createToast({
          txt: '修改后保存',
          type: 'txt'
        }).show()
        return false
      } else if (!reg.test(this.modifyName)) {
        this.toast = this.$createToast({
          txt: '名称不合法',
          type: 'txt'
        }).show()
        return false  
      }
      this.setCellular()
    }
  },
  mounted () {
    Common.setTitle('备注日历名称')
    // this.getCellular()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.container
  background #ffffff;
  .item
    padding 24px 15px 0
  .tip
      font-size 12px
      // line-height 30px
      margin-top 15px
      margin-left 15px
      color #333333
    //   text-align center
  .cube-input
    background-color #efefef
  .btnsave
    background-color #000000
    margin-top 165px
    margin-left 20px
    width 89.3vw
    height 44px
    font-size 16px 
    color #FFFFFF

</style>


// WEBPACK FOOTER //
// src/pages/ModifyCalendarname/ModifyCalendarname.vue